export function getCallRailFallbackFields() {
  if (typeof window === "undefined") {
    return {
      referrer: "Direct",
      referring_url: "/referring-url",
      landing_page_url: "/landing-page",
    };
  }

  const rawReferrer = document.referrer || "";
  const rawLanding =
    sessionStorage.getItem("landing_page_url") || window.location.href || "";

  const isLocal = rawLanding.startsWith("http://localhost");

  return {
    referrer: rawReferrer || "Direct",
    referring_url: rawReferrer || "/referring-url",
    landing_page_url: isLocal ? "/landing-page" : rawLanding,
  };
}

export function getSafeCallRailSessionId() {
  // SSR-safe
  if (typeof window === "undefined") return null;

  // Raw storage value (may contain garbage)
  const raw = localStorage.getItem("calltrk-calltrk_session_id") || "";

  // Strict extraction regex:
  // finds the first valid UUID inside any string
  const match = raw.match(
    /\b[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\b/,
  );

  if (!match) return null;

  const uuid = match[0];

  // Extra safety: strict UUID format check
  const isValidUUID =
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(
      uuid,
    );

  return isValidUUID ? uuid : null;
}

export const getName = (formData) => {
  const isSubscriber =
    String(formData?.is_subscriber_patient).toLowerCase() === "true";

  const name =
    formData?.relationship_to_patient === "Patient"
      ? isSubscriber
        ? `${formData?.subscriber_first_name} ${formData?.subscriber_last_name}` // patient is subscriber
        : `${formData?.patient_first_name} ${formData?.patient_last_name}` // patient is dependent
      : formData?.name; // not the patient, use entered name
  return name || "";
};
